import { withInstall } from '../../../utils/with-install'
import Circle from './Circle.vue'

export const ElAmapCircle = withInstall(Circle)
export default ElAmapCircle
